import ReviewModalContainer from '../../containers/ReviewModalContainer';
import { useProductCartNames } from '../../../../common/custom-hooks/productCartNames';

const ReviewModalTextResolver = (props) => {
  const productNames = useProductCartNames();

  return <ReviewModalContainer productNames={productNames} {...props} />;
};

export default ReviewModalTextResolver;
